import '@/assets/main.css'

import { bootstrap } from '@/boot'

bootstrap().then((app) => app.mount('#app'))
